import * as stylex from '@stylexjs/stylex';
import { createFileRoute } from '@tanstack/react-router';

import { ErrorState } from '@/components/error-state.component';
import { NotFoundState } from '@/components/not-found-state.component';
import { Skeleton } from '@/libs/serenity-ui';
import { breakpoints } from '@/libs/serenity-ui/constants.stylex';

export const Route = createFileRoute('/_app/_list')({
  pendingComponent: PendingState,
  errorComponent: ErrorState,
  notFoundComponent: NotFoundState,
});

function PendingState() {
  return (
    <div {...stylex.props(styles.base)}>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
      <div {...stylex.props(skeletonGroupStyles.base)}>
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={[skeletonStyles.base, skeletonStyles.fullWidth]} />
        <Skeleton style={skeletonStyles.base} />
      </div>
    </div>
  );
}

const styles = stylex.create({
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: {
      default: 0,
      [breakpoints.large]: 38,
    },
    width: '100%',
  },
});

const skeletonGroupStyles = stylex.create({
  base: {
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    justifyContent: 'flex-end',
    paddingBlock: {
      default: 16,
      [breakpoints.large]: 0,
    },
    paddingInline: {
      default: 20,
      [breakpoints.large]: 0,
    },
  }
});

const skeletonStyles = stylex.create({
  base: {
    height: 20,
    width: 77,
  },
  fullWidth: {
    width: '100%'
  },
});
